import { render, staticRenderFns } from "./editAttrSpec.vue?vue&type=template&id=a8878df2"
import script from "./editAttrSpec.vue?vue&type=script&lang=js"
export * from "./editAttrSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports